import ConfigCategory from "./interfaces/ConfigItem";

const config: ConfigCategory[] = [
	{
		name: "Need Something?",
		icon: "handsHoldingChild",
		description: "IT support or equipment request\nAcommodation\nBook a toll charge\nPersonal issue",
		items: [
			{
				name: "IT support or equipment request",
				description: "Request IT support or IT equipment",
				icon: "display",
				link: "https://support.bridgeway.consulting",
				keywords: [ "computer, help, ticket, fault, issue, problem, equipment, mobile, tablet, email, system" ]
			},
			{
				name: "Accommodation",
				description: "Request accommodation",
				icon: "hotel",
				link: "https://bss.bridgeway.consulting",
				keywords: [ "hotel, trivago" ],
			},
			{
				name: "Book a toll charge",
				description: "Book a charge for a toll crossing or zone",
				icon: "roadBarrier",
				link: "https://tolls.bridgeway.consulting",
				disabled: false,
				keywords: [ "crossing", "zone", "ulez" ],
			},
			{
				name: "Personal issue",
				description: "PPE and equipment requests",
				icon: "peopleGroup",
				link: "#",
				disabled: true,
				keywords: [ "ppe" ]
			},
		],
	}, 
	{
		name: "Report Something?",
		icon: "exclamationTriangle",
		items: [
			{
				name: "Close Call",
				description: "Report a close call",
				icon: "exclamationTriangle",
				link: "https://closecall.bridgeway.consulting",
			},
			{
				name: "Commercial Close Calls",
				description: "Report commercial close calls",
				icon: "coins",
				link: "https://ccc.bridgeway.consulting",
			},
			{
				name: "Equipment Defect (D.I.R.T)",
				description: "Report a defect with Bridgeway Equipment",
				icon: "tools",
				link: "https://dirt.bridgeway.consulting",
			},
			{
				name: "Facilities Issue",
				description: "Report a facilities issue.",
				icon: "houseCrack",
				link: "https://facilities.bridgeway.consulting",
			},
			{
				name: "Online Accident Book",
				description: "Report an accident via the First Aid reporting tool.",
				icon: "personFalling",
				link: "https://firstaid.bridgeway.consulting",
			},
			{
				name: "Vehicle Defect",
				description: "Report a defect with a Bridgeway Vehicle",
				icon: "van",
				link: "https://fm.bridgeway.consulting/defects/create",
			},
			{
				name: "Site Logs - DAS",
				description: "Site Logs & Reporting Tools",
				icon: "fileSignature",
				link: "#",
				disabled: true,
			},
			{
				name: "Vehicle Accident",
				description: "Report an accident in a Bridgeway Vehicle",
				icon: "carAccident",
				link: "#",
				disabled: true,
			},
			
		],
	},
	{
		name: "Useful Information",
		icon: "infoCircle",
		items: [
			{
				name: "Assurance",
				icon: "helmetSafety",
				items: [
					{
						name: "Company Policies",
						description: "Company Policies",
						icon: "book",
						link: "https://resources.bridgeway.consulting/resource/view/6",
					},
					{
						name: "Safety Documents",
						description: "Useful documents",
						icon: "infoCircle",
						link: "https://resources.bridgeway.consulting/resource/view/13",
					},
				]
			},
			{
				name: "Fleet",
				description: "",
				icon: "van",
				items: [
					{
						name: "Fleet Documents",
						description: "View Fleet document library",
						icon: "folder",
						link: "https://resources.bridgeway.consulting/resource/view/3",
					},
					{
						name: "Fuel Card Petrol Stations",
						description: "Find stations that support our fuel cards.",
						icon: "creditCard",
						link: "https://www.erouteonline.com/v7/ukfuels/"
					},
				],
			},
			{
				name: "Shared Documents",
				icon: "openfolder",
				link: "https://resources.bridgeway.consulting/resource",
			},
			{
				name: "Staff Manuals",
				description: "Staff Manuals",
				icon: "book",
				link: "https://resources.bridgeway.consulting/resource/view/20",
			},
			{
				name: "Company Information",
				description: "Company policies, forms, manuals and more.",
				icon: "book",
				link: "https://resources.bridgeway.consulting/resource/view/19",
			},
			{
				name: "Company Policies",
				description: "Company Policies",
				icon: "book",
				link: "https://resources.bridgeway.consulting/resource/view/6",
			},
			{
				name: "Contract for Services Essentials",
				description: "Important CFS Information Guides",
				icon: "book",
				link: "https://resources.bridgeway.consulting/resource/view/27",
			},
			{
				name: "Medication Information",
				description: "Medication fact sheet, video and form",
				icon: "suitcaseMedical",
				items: [
					{
						name: "Medication Safety Video",
						description: "Bridgeways regular drugs & alcohol testing policy",
						icon: "film",
						link: "https://videos.bridgeway.consulting/#/watch/YO47Vdr4Nws",
					},
					{
						name: "Medication Fact Sheet",
						description: "Factsheet to support you if taking medication",
						icon: "qa",
						link: "https://resources.bridgeway.consulting/resource/view/13?path=Medication&file=Medication+-+Fact+Sheet.pdf",
					},
					{
						name: "Medication Check Form",
						description: "Medication tracker for medicals",
						icon: "file",
						link: "https://resources.bridgeway.consulting/resource/view/13?path=Medication&file=Medication+Check+Form+%28Individual+to+complete%29.docx",
					}
				]
			},
			{
				name: "Leadership Team",
				icon: "peopleGroup",
				description: "See who's in Bridgeway's Leadership Team",
				link: "https://bridgeway.help/leadership-team",
			},
		],
	},
	{
		name: "Useful Links",
		icon: "link",
		items: [
			{
				name: "BMS",
				description: "Bridgeway Management System",
				icon: "tableColumns",
				link: "https://bms.bridgeway.consulting"
			},
			{
				name: "Company Website",
				description: "Bridgeway Main Website",
				icon: "gears",
				link: "https://bridgeway-consulting.co.uk",
			},
			{
				name: "Engage Online",
				description: "Engage Online staff portal",
				icon: "engage",
				link: "https://engage.bridgeway.consulting",
				keywords: [ "timesheet", "address", "details", "bank" ],
			},
			{
				name: "Enplan",
				description: "Enplan Shift Planning System",
				icon: "calendar",
				link: "https://enplan.bridgeway.consulting",
				keywords: [ "shift", "planning" ]
			},
			{
				name: "OnCall Info",
				description: "OnCall Information Sheet",
				icon: "infoCircle",
				link: "https://bridgewayconsultinglimited.sharepoint.com/:x:/r/sites/FileSharing/_layouts/15/doc2.aspx?sourcedoc=%7B05102F87-7A0F-4207-9BC1-D1E18469FEAA%7D&file=OCM%20BCL%20Information.xlsx&action=default&mobileredirect=true&cid=F0CA2198-EE55-4EF2-AF24-3583B2024101",
			},
			{
				name: "Rulebooks",
				description: "Track Workers Manual and Rulebook",
				icon: "book",
				link: "https://resources.bridgeway.consulting/resource/view/13?path=Rulebook",
				keywords: [ "track", "manual", "rule", "book", "rulebook" ],
			},
			{
				name: "Staff Suggestions",
				description: "Suggest ideas and changes within Bridgeway",
				icon: "comments",
				link: "https://engage.bridgeway.consulting/staffsuggestions.aspx"
			},
			{
				name: "Site Assistant",
				description: "Plan and record mentored site visits",
				icon: "train",
				link: "https://siteassistant.bridgeway.consulting"
			},
			{
				name: "Bridgeway Webmail",
				description: "Online email for bridgewayemail.com",
				icon: "envelope",
				link: "https://webmail.bridgewayemail.com",
				disabled: false,
			},
			{
				name: "Teams Backgrounds",
				description: "Bridgeway branded backgrounds for use in Teams Meetings",
				icon: "image",
				link: "https://resources.bridgeway.consulting/resource/view/19?view=grid&path=BCL+Banners%2C+Templates%2C+Logos%2C+Calendar%2FCorporate+Templates%2FTeams+Background"
			},
			{
				name: "Software Development Request",
				description: "Request a software development project",
				icon: "code",
				link: "https://forms.office.com/Pages/ResponsePage.aspx?id=xyDeV8cewUywX9VbQGw3r0-OBQJCPV5HtKO45AGDrJJUNzhORDBHSDZOUUVFSVZENllKUjVZVjFQQiQlQCN0PWcu&origin=Invitation&channel=0"
			},
			{
				name: "Quarterly 1:1's",
				description: "Bridgeways Appraisals Reimagined",
				icon: "comments",
				link: "https://engage-online.bridgeway.consulting/"
			},
			{
				name: "eLearning",
				description: "Bridgeways ELearning Platform",
				icon: "graduationCap",
				link: "https://elearning.bridgeway.consulting/",
				keywords: ["moodle", "learning", "elearning"],
			},
			{
				name: "Chain of Custody - Sample Logger",
				icon: "book",
				exact: true,
				link: "/ross/coc_sample_logger.html"
			},
			{
				name: "Daily Allocation Sheet",
				icon: "book",
				exact: true,
				link: "/forms/das_form.html"
			},
			{
				name: "Rig Check Sheet",
				icon: "book",
				exact: true,
				link: "/ross/rig_check_sheet.html"
			},
			{
				name: "Audits",
				description: "Bridgeway Auditing System",
				icon: "clipboard",
				link: "https://audits.bridgeway.consulting",
			},
		],
	},
	{
		name: "Media",
		icon: "film",
		link: "https://videos.bridgeway.consulting",
	},
	{
		name: "eLearning",
		icon: "graduationCap",
		link: "https://elearning.bridgeway.consulting",
	},
	{
		name: "Resources",
		icon: "openfolder",
		link: "https://resources.bridgeway.consulting",
	},
	{
		name: "Wellbeing",
		icon: "wellbeing",
		items: [
			{
				name: "Health Hero",
				description: "Confidential employee support line",
				icon: "healthHero",
				link: "modal://health-hero",
				keywords: ["health", "hero", "healthhero", "health-hero", "validium"],
			},	
			{
				name: "Wellbeing Champions",
				description: "Bridgeway Health & Wellbeing Champions",
				icon: "wellbeing",
				link: "https://engage.bridgeway.consulting/wellbeing-champions.aspx",
				keywords: [ "wellbeing", "champions", "health" ]
			},
		],
	}
];
export default config;